/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/html",
  category: "formatting",
  attributes: {
    content: {
      type: "string",
      source: "html"
    }
  }
};
import save from './save';
import transforms from './transforms';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Custom HTML'),
  description: __('Add custom HTML code and preview it as you edit.'),
  icon: icon,
  keywords: [__('embed')],
  example: {
    attributes: {
      content: '<marquee>' + __('Welcome to the wonderful world of blocks…') + '</marquee>'
    }
  },
  supports: {
    customClassName: false,
    className: false,
    html: false
  },
  transforms: transforms,
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map